(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7913],{

/***/ 94324:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internships",
      function () {
        return __webpack_require__(25327);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://www.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 84623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65822);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78409);
/* harmony import */ var _utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3265);
/* harmony import */ var _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90017);










const NeedGuidance = ({ classname , button2Data  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const applyCtaButtonProps1 = (0,_utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__/* .getOnboardingOrFormCtaProps */ .J)(router, {
        btnLink: button2Data?.link,
        formId: button2Data?.formId,
        toOnboardingEnabled: button2Data?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,_utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__/* .persistSourceContext */ .jW)({
                    sourceUrl: window.location.href,
                    primarySource: _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__/* .PRIMARY_SOURCE_B2C_WIDGET */ .ov,
                    fifthStepVisible: button2Data?.nearestOffice ?? true,
                    coachingVisible: button2Data?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "need-guidance",
            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        style: {
                                            fontSize: "26px"
                                        },
                                        children: "Need guidance? Let us help you."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/contact-us",
                                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btTranparent),
                                            children: "Contact Us"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: `${(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().enquireBtn)} ${classname || ""} ${applyCtaButtonProps1.formClassName}`,
                                            onClick: button2Data ? ctaBtnClickHandler(applyCtaButtonProps1) : undefined,
                                            children: button2Data?.title ?? "Enquire Now"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NeedGuidance);


/***/ }),

/***/ 3011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42547);
/* harmony import */ var _styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54076);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70710);










const FaqComponent = (props)=>{
    const { 0: isViewMore , 1: setIsViewMore  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: showCardDetail , 1: setShowCardDetail  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().faqComponent),
        style: {
            backgroundColor: props.sectionBgColor || "#EFEFFA"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-center",
                                    children: props.title
                                }),
                                props.description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                    children: props.description
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: props.subTitle1
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: props.subTitle2
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            children: props.subTitle3
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                            children: props.faqPoints?.length > 0 && props.faqPoints.map((faqsdata, index)=>{
                                const condition = !isViewMore ? index < 5 : index >= 0;
                                const key = index.toString();
                                return condition && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    xl: 8,
                                    lg: 8,
                                    md: 8,
                                    sm: 8,
                                    xs: 8,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        activeKey: showCardDetail,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Item */ .Z.Item, {
                                            className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().stuAccordion),
                                            eventKey: key,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Header */ .Z.Header, {
                                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accoHead),
                                                    onClick: ()=>{
                                                        if (showCardDetail === key) {
                                                            setShowCardDetail(null);
                                                        } else {
                                                            setShowCardDetail(key);
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            style: {
                                                                color: ` ${showCardDetail === key ? "#0c63e4" : "#201f22"}`
                                                            },
                                                            children: [
                                                                " ",
                                                                faqsdata.title
                                                            ]
                                                        }),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Accordion__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accorBody),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: faqsdata.description
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }, index);
                            })
                        }),
                        props.faqPoints?.length > 5 && !isViewMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mt-4 mb-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    id: "faq-component",
                                    onClick: ()=>{
                                        setIsViewMore(true);
                                    },
                                    className: (_styles_pstlandingpage_module_scss__WEBPACK_IMPORTED_MODULE_5___default().viewMore),
                                    children: "View More"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqComponent);


/***/ }),

/***/ 537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(82908);
/* harmony import */ var _styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78182);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45992);
/* harmony import */ var _utils_fetchUtil__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40607);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59830);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70710);













const Testimonial = ({ title , bgColor , slug , data  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: testimonialData , 1: setTestimonialData  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const { 0: centerSlide , 1: setCenterSlide  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const settings = {
        dotsClass: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().sliderDots),
        dots: false,
        infinite: false,
        speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.desktopSpeed */ .Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        initialSlide: 1,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .sliderSpeed.mobileSpeed */ .Y$.mobileSpeed,
                    arrows: false,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 200
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    dots: false
                }
            }
        ]
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        data ? setTestimonialData(data) : (0,_utils_fetchUtil__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(`${"https://cms.studies-overseas.com"}/${slug}`, "GET", {}, "", false).then((res)=>setTestimonialData(res));
    }, []);
    return testimonialData?.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        id: "studenttestimonial",
        className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().studentTestSlider),
        style: {
            backgroundColor: bgColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "mb-5 text-center",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "studentmm",
                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().student),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    ...settings,
                                    ref: sliderRef,
                                    className: `${(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().slider)}`,
                                    children: testimonialData.map((slide, ind)=>{
                                        return ind < 15 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                className: `${(_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().stuTestCard)}`,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Body */ .Z.Body, {
                                                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cardBody),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                            width: "33",
                                                            height: "22",
                                                            viewBox: "0 0 33 22",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z",
                                                                    fill: "#226CF5"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z",
                                                                    fill: "#226CF5"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "my-4",
                                                            children: slide?.testimonial?.message
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                            className: "mb-0",
                                                            children: slide?.testimonial?.name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().addre),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: slide?.testimonial?.details
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: slide?.testimonial?.subDetails
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }, ind);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().arrowsClass),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickPrev(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/left-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "left-arrow"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_studentservices_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btcircle),
                                            onClick: ()=>sliderRef?.current?.slickNext(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/new-images/right-arrow.svg",
                                                height: 17,
                                                width: 10,
                                                alt: "right-arrow"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Testimonial);


/***/ }),

/***/ 25327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ internships; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/internships.module.scss
var internships_module = __webpack_require__(89684);
var internships_module_default = /*#__PURE__*/__webpack_require__.n(internships_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/NeedGuidance.tsx
var NeedGuidance = __webpack_require__(84623);
// EXTERNAL MODULE: ./components/WebinarEvents.tsx
var WebinarEvents = __webpack_require__(72350);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./components/Testimonial.tsx
var Testimonial = __webpack_require__(537);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
// EXTERNAL MODULE: ./components/kcNewlatestupdates.tsx
var kcNewlatestupdates = __webpack_require__(79465);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./components/PST/FrequentlyAskedQuestions.tsx
var FrequentlyAskedQuestions = __webpack_require__(3011);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/Internships.tsx


















const Internship = (props)=>{
    const initialValues = {
        country: "USA",
        searchValue: "",
        pageNo: 1
    };
    const { 0: filters , 1: setFilters  } = (0,react.useState)(initialValues);
    const { 0: interships , 1: setInternships  } = (0,react.useState)(props.intershipsData);
    const { 0: searchKeyword , 1: setSearchKeyword  } = (0,react.useState)("");
    const { 0: searchQuery , 1: setSearchQuery  } = (0,react.useState)({});
    const { 0: totalPages , 1: setTotalPages  } = (0,react.useState)(0);
    const { country , searchValue , pageNo  } = filters;
    const debounceSearchQuery = (searchKeyValue)=>{
        const search = debounce_default()(()=>setFilters({
                ...filters,
                searchValue: searchKeyValue
            }), 500);
        setSearchQuery((prevSearch)=>{
            if (prevSearch.cancel) {
                prevSearch.cancel();
            }
            return search;
        });
        search();
    };
    (0,react.useEffect)(()=>{
        const url = searchValue ? `&name_contains=${searchValue}` : "";
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/country-internships?country=${country.replace(/ /g, "")}&_start=${(pageNo - 1) * 3}&_limit=${3}${url}`, "GET", {}, "", false).then((res)=>{
            setInternships(res);
        });
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/country-internships/count?country=${country.replace(/ /g, "")}${url}`, "GET", {}, "", false).then((res)=>{
            setTotalPages(Math.ceil(res / 3));
        });
    }, [
        filters
    ]);
    const totalPagesArray = Array.from(Array(totalPages).keys());
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "debounce-search-query",
                className: (internships_module_default()).edtech,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (internships_module_default()).breadcrum,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    lg: 8,
                                    md: 8,
                                    xs: 12,
                                    className: (internships_module_default()).centered,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                    style: {
                                                        opacity: 0.5
                                                    },
                                                    href: "/",
                                                    children: "Home"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                    href: "",
                                                    children: " Internships "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (internships_module_default()).abttopContent,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (internships_module_default()).abttopContentdesk,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        children: props?.pageData?.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: props?.pageData?.description
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            id: "enquirebtn",
                                            variant: "primary",
                                            size: "lg",
                                            className: `${(internships_module_default()).enquirebtn} btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props.pageData?.meta?.jotforms[0]?.jotformid || "241383394530456")}`,
                                            children: props?.pageData?.bannerBtn?.label || "Enquire Now"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    md: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            md: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (internships_module_default()).parentMain,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (internships_module_default()).first,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: props?.pageData?.mainImageOneUrl,
                                                            width: 770,
                                                            height: 400,
                                                            alt: props?.pageData?.mainImageOneAltTag
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (internships_module_default()).second,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (internships_module_default()).childa,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: props?.pageData?.mainImageTwoUrl,
                                                                width: 370,
                                                                height: 400,
                                                                alt: props?.pageData?.mainImageTwoAltTag
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "study-contnt",
                className: (internships_module_default()).studyContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: props?.pageData?.futureReady?.sectionTitle
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (internships_module_default()).service_content,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: props?.pageData?.futureReady?.sectionImageUrl,
                                        width: 490,
                                        height: 444,
                                        alt: props?.pageData?.futureReady?.sectionImageAltTag
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (internships_module_default()).offers,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (internships_module_default()).content,
                                            children: props?.pageData?.futureReady?.sectionDescription
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: props?.pageData?.futureReady?.sectionPoints?.length > 0 && props?.pageData?.futureReady?.sectionPoints.map((point, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: point
                                                }, index))
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "seven-step",
                className: (internships_module_default()).sevenSteps,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: props?.pageData?.sevenSteps?.sectionTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 10,
                                    lg: 5,
                                    className: (internships_module_default()).centered,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (internships_module_default()).decimals,
                                                        children: "1"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/couselling-icon.svg",
                                                            alt: "cousellingIco.svg",
                                                            width: 40,
                                                            height: 40
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Counselling"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Plan your Academic and Career Goals"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (internships_module_default()).decimals,
                                                        children: "2"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/test-prep.svg",
                                                            alt: "testPrep.svg",
                                                            width: 40,
                                                            height: 40
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Test Preparation"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Appear for Standardized Tests"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (internships_module_default()).decimals,
                                                        children: "3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/course-icon.svg",
                                                            alt: "courseIco.svg",
                                                            width: 40,
                                                            height: 40
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Course, Country & University Selection"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Select the Country, the Program and the University"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (internships_module_default()).decimals,
                                                        children: "4"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/applic-icon.svg",
                                                            alt: "applicIco.svg",
                                                            width: 40,
                                                            height: 40
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Application & Admission"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Apply to your Preferred Universities or Institutions"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 10,
                                    lg: 5,
                                    className: (internships_module_default()).centered,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (internships_module_default()).decimals,
                                                        children: "5"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/edu-loan-icon.svg",
                                                            alt: "eduLoanIco.svg",
                                                            width: 40,
                                                            height: 40
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Education Loan & Financials"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Apply for Education Loan and Arrange Requisite Financials"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (internships_module_default()).decimals,
                                                        children: "6"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/visa-icon.svg",
                                                            alt: "visaIco.svg",
                                                            width: 40,
                                                            height: 40
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Visa Processing"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Pay your Deposit, Accept your Offer and Apply for Visa"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (internships_module_default()).decimals,
                                                        children: "7"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/new-images/addisuppico.svg",
                                                            alt: "addiSuppIco.svg",
                                                            width: 40,
                                                            height: 40
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                children: "Additional Support"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Attend Pre-Departure Session, Avail Forex & Insurance and Fly Abroad"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarEvents["default"], {
                    headingLevel: 2
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, {
                title: "Our students love us",
                bgColor: "#FFFFFF",
                slug: `student-testimonials?type=coaching&_limit=15&_sort=id:DESC`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (internships_module_default()).homePageLatestKcUpdates,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(kcNewlatestupdates["default"], {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (internships_module_default()).homePageBlogs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NeedGuidance/* default */.Z, {
                    classname: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`
                })
            }),
            props.pageData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions/* default */.Z, {
                ...props.pageData.faq
            })
        ]
    });
};
/* harmony default export */ var Internships = (Internship);

// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
;// CONCATENATED MODULE: ./pages/internships.tsx




const internships_Internships = (props)=>{
    const { meta  } = props.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Internships, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var internships = (internships_Internships);


/***/ }),

/***/ 65822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentFooter":"NeedGuidance_studentFooter__5o74_","session":"NeedGuidance_session__8Zc7c","anchor":"NeedGuidance_anchor__9XZiq","enquireBtn":"NeedGuidance_enquireBtn__u9ZDM","btTranparent":"NeedGuidance_btTranparent__iNGT9"};

/***/ }),

/***/ 89684:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"abttopContent":"internships_abttopContent__FPxWn","abttopContentdesk":"internships_abttopContentdesk__V9I8b","edtech":"internships_edtech__0lt41","parentMain":"internships_parentMain__F3zEa","first":"internships_first__gi7No","second":"internships_second__DcCol","childa":"internships_childa__Evwa2","breadcrum":"internships_breadcrum__NqjkK","enquirebtn":"internships_enquirebtn__NgJtc","heading":"internships_heading__hnbkv","buttongp":"internships_buttongp__VVhzN","kcbtn":"internships_kcbtn__DfSOz","centered":"internships_centered__XCwUH","breadcrumb-item":"internships_breadcrumb-item__2QhJL","active":"internships_active__qxplH","mainTitle":"internships_mainTitle__SZnKx","studyContent":"internships_studyContent__8aGc8","service_content":"internships_service_content__DmOPi","studyAnchor":"internships_studyAnchor__thr6t","indusContent":"internships_indusContent__TbnrU","internshipAche":"internships_internshipAche__MaM_A","topResult":"internships_topResult__7okf3","country_flags":"internships_country_flags__YV72h","flagImgContent":"internships_flagImgContent__EQXiY","scholaershipResult":"internships_scholaershipResult__SDHyn","flagposition":"internships_flagposition__COuM0","sevenSteps":"internships_sevenSteps__Cu9zv","decimals":"internships_decimals__c_jwa","ourStudent":"internships_ourStudent__GrC56","homePageLatestKcUpdates":"internships_homePageLatestKcUpdates__04pxh","homePageBlogs":"internships_homePageBlogs__GkCQi","inputBox":"internships_inputBox__y0Ldi","inputBtn":"internships_inputBtn__SA57p"};

/***/ }),

/***/ 42547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"pstlandingpage_banner__g_UPf","nav":"pstlandingpage_nav__QrKZh","navLogo":"pstlandingpage_navLogo__rYw7Z","maincontent":"pstlandingpage_maincontent__tcl1X","fairdetails":"pstlandingpage_fairdetails___3Awg","heading":"pstlandingpage_heading__CmSZI","ulli":"pstlandingpage_ulli__fqPBp","liItem":"pstlandingpage_liItem__kE_QJ","regBtn":"pstlandingpage_regBtn__SXSXv","reg":"pstlandingpage_reg__808jO","enq":"pstlandingpage_enq__YbXM2","btnReg":"pstlandingpage_btnReg__ifx_Y","bannerStudDiv":"pstlandingpage_bannerStudDiv__h0Iis","bg":"pstlandingpage_bg__EOIvU","WhyKc":"pstlandingpage_WhyKc__aTj1F","viewMore":"pstlandingpage_viewMore__57U7q","whyMb":"pstlandingpage_whyMb__E2tnD","bussiness":"pstlandingpage_bussiness__8M5jS","uni":"pstlandingpage_uni__iGGja","img":"pstlandingpage_img__zoQjU","logo":"pstlandingpage_logo__PhEVL","sliderdiv":"pstlandingpage_sliderdiv__WSqCW","capabilityBg":"pstlandingpage_capabilityBg__e8FfP","content":"pstlandingpage_content__Lr07i","subcontent":"pstlandingpage_subcontent__bduG9","imgRow":"pstlandingpage_imgRow__5PEei","steps":"pstlandingpage_steps__uo121","points":"pstlandingpage_points__Qc5ZJ","mainbox":"pstlandingpage_mainbox__2nHev","boximg":"pstlandingpage_boximg___iqhq","association":"pstlandingpage_association__KcsWN","custCard":"pstlandingpage_custCard__2dOTw","imgDiv":"pstlandingpage_imgDiv__zKq9h","cardBody":"pstlandingpage_cardBody__5VPch","mainDiv":"pstlandingpage_mainDiv__E_si7","div":"pstlandingpage_div__12NSx","footer":"pstlandingpage_footer__UMKA1","footerlogo":"pstlandingpage_footerlogo__r5ngN","activeClass":"pstlandingpage_activeClass__XLLQe","arrowsClass":"pstlandingpage_arrowsClass___Haw3","btcircle":"pstlandingpage_btcircle__Sy1vj","sliderDots":"pstlandingpage_sliderDots__f2brx","elanLoansComp":"pstlandingpage_elanLoansComp__Xu5qO","elanContent":"pstlandingpage_elanContent__a4FxP","elanSubheading":"pstlandingpage_elanSubheading__MZ9zo","slider":"pstlandingpage_slider__ux_j6","imageDiv":"pstlandingpage_imageDiv__zXYkn","countryName":"pstlandingpage_countryName__y5U_f","button":"pstlandingpage_button__Hj8FU","enquirebtn":"pstlandingpage_enquirebtn__HXtlR","achievements":"pstlandingpage_achievements__4uMWW","description":"pstlandingpage_description__9Po_q","containerDiv":"pstlandingpage_containerDiv__1iO_z","sliderContainer":"pstlandingpage_sliderContainer__BD5UY","achievementsDiv":"pstlandingpage_achievementsDiv__gDUMc","icon":"pstlandingpage_icon__6cN3s","studVideo":"pstlandingpage_studVideo__57n8X","videoDiv":"pstlandingpage_videoDiv__gcrFA","videos":"pstlandingpage_videos__mNRB3","faqComponent":"pstlandingpage_faqComponent__DG96z","box":"pstlandingpage_box__dSteF","stuAccordion":"pstlandingpage_stuAccordion__0Carb","accoHead":"pstlandingpage_accoHead__5gc_W","card":"pstlandingpage_card___j1YG","cardImgDiv":"pstlandingpage_cardImgDiv__ANALH","cardImg":"pstlandingpage_cardImg__n_32_","caption":"pstlandingpage_caption___TAdQ","caption2":"pstlandingpage_caption2__V6haF","localeButton":"pstlandingpage_localeButton__N8bhp","selectClass":"pstlandingpage_selectClass__l1KDY"};

/***/ }),

/***/ 82908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentServicesPage":"studentservices_studentServicesPage__jDBb9","studentServicesCurve":"studentservices_studentServicesCurve__V6eKt","contentDiv":"studentservices_contentDiv__wEbZf","enquirebtn":"studentservices_enquirebtn__ld5mL","servContent":"studentservices_servContent__PL5SN","WhyKc":"studentservices_WhyKc__sZxHm","viewMore":"studentservices_viewMore__bN0nA","img":"studentservices_img__H06y5","studentServicesWebinarEvent":"studentservices_studentServicesWebinarEvent__YR1_a","studentHelpMainDiv":"studentservices_studentHelpMainDiv__1GWsb","studentHelp":"studentservices_studentHelp__1fO7O","alignTop":"studentservices_alignTop__iMtE_","subAnchor":"studentservices_subAnchor__jRKHU","knowMore":"studentservices_knowMore__Y1q7q","linksDiv":"studentservices_linksDiv__KAP9F","studentServicesKcUpdates":"studentservices_studentServicesKcUpdates__LWcWL","StudentBlogs":"studentservices_StudentBlogs__TKFes","studentFooter":"studentservices_studentFooter__C7T7a","session":"studentservices_session__I15Qa","student":"studentservices_student__R_JgR","middelStuTest":"studentservices_middelStuTest__JJpvH","stuTestCard":"studentservices_stuTestCard__s_G5N","cardBody":"studentservices_cardBody__fAO4I","addre":"studentservices_addre__cGp__","studentTestSlider":"studentservices_studentTestSlider__bff6C","sevenBG":"studentservices_sevenBG__ovks8","sliderDots":"studentservices_sliderDots__PrfDo","slick-slide":"studentservices_slick-slide__Zwpji","slick-center":"studentservices_slick-center__42LQ5","arrowsClass":"studentservices_arrowsClass__pblWv","btcircle":"studentservices_btcircle__uDqgR","arrowsClasses":"studentservices_arrowsClasses__SQl3Q"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,3656,6877,474,5684,9465,2350,3593,9774,2888,179], function() { return __webpack_exec__(94324); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);